import type { User } from '../services/authService';

// El perfil asociado al nivel agrupa administradores y operadores como personal.
export const getProfileRoute = (user: Pick<User, 'perfil'> | null | undefined) =>
    user?.perfil === 'personal' ? '/profile' : '/perfil';

// La plataforma pública del cliente y el panel operativo son experiencias
// distintas. El perfil asociado es la fuente de verdad, también para admins.
export const getPlatformRoute = (user: Pick<User, 'perfil'> | null | undefined) =>
    user?.perfil === 'personal' ? '/dashboard' : '/midashboard';
